import { USERS, SIGNUP } from './UsersActions';
import { Map } from 'immutable';

let defaultState = new Map({
  isFetching: false,
  error: false,
  data: []
});

export default function users(state = defaultState, action) {
  switch (action.type) {
    case USERS.REQUEST:
      return Map({
        isFetching: action.isFetching
      });
    case USERS.SUCCESS:
      return Map({
        isFetching: action.isFetching,
        data: action.payload
      });
    case USERS.FAILURE:
      return Map({
        isFetching: action.isFetching,
        error: action.error
      });
    case USERS.RESET:
      return Map({
        isFetching: false,
        error: false,
        data: []
      });
    default:
      return state;
  }
}

export function signup(state = new Map({
  isFetching: false,
  error: false,
  data: []
}), action) {
  switch (action.type) {
    case SIGNUP.REQUEST:
      return state.merge(Map({
        isFetching: action.isFetching
      }));
    case SIGNUP.SUCCESS:
      return state.merge(Map({
        isFetching: action.isFetching,
        data: action.payload
      }));
    case SIGNUP.FAILURE:
      return state.merge(Map({
        isFetching: action.isFetching,
        error: action.error
      }));
    case SIGNUP.RESET:
      return state.merge(Map({
        isFetching: false,
        error: false,
        data: []
      }));
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/containers/Users/UsersReducer.js